import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { TrustPhoneNotice } from './item';
import { trustPhoneDevices } from 'entities/device.trust-phones/model';
export const TrustPhonesNotice = memo(function TrustPhonesNotice() {
    const devices = useAppSelector(trustPhoneDevices);
    if (devices.length == 0) {
        return null;
    }
    return (_jsx(ErrorBoundary, { children: devices.slice(0, 3).map((device) => (_jsx(TrustPhoneNotice, { device: device }, device.id))) }));
});
